import { render, staticRenderFns } from "./InclusaoOcorrenciaDetalhes.vue?vue&type=template&id=6842b5c8"
import script from "./InclusaoOcorrenciaDetalhes.vue?vue&type=script&lang=js"
export * from "./InclusaoOcorrenciaDetalhes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports